import event from "../resources/event.json";

// const getRemainingVideos = () => {
//   let aux = [];
//   event.days.forEach((day) => {
//     day.videos.forEach((video) => {
//       if (new Date() > new Date(video.endAt)) {
//         aux.push(video);
//       }
//     });
//   });
//   return aux;
// };

export const getPastVideos = () => {
  let aux = [];
  event.days.forEach((day) => {
    day.videos.forEach((video) => {
      if (new Date() > new Date(video.endAt)) {
        aux.push(video);
      }
    });
  });
  return aux;
};

export const eventEnded = () => {
  return new Date() > new Date(event.endAt);
};
